/**
 * Safe date formatting utility
 * Handles string dates, Date objects, and null/undefined values
 */

export function formatDate(date: string | Date | undefined | null): string {
  if (!date) {
    return 'Unknown date'
  }

  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date

    if (isNaN(dateObj.getTime())) {
      return 'Invalid date'
    }

    return dateObj.toLocaleDateString()
  } catch (error) {
    return 'Invalid date'
  }
}

export function formatDateTime(date: string | Date | undefined | null): string {
  if (!date) {
    return 'Unknown date'
  }

  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date

    if (isNaN(dateObj.getTime())) {
      return 'Invalid date'
    }

    return dateObj.toLocaleString()
  } catch (error) {
    return 'Invalid date'
  }
}
